// src/getters/libraryCardGetters.js
export const getLibraryCards = (state) => state.libraryCards.data;
export const getLibraryCardLoading = (state) => state.libraryCards.loading;
export const getLibraryCardError = (state) => state.libraryCards.error;
export const getPresignedUrl = (state) => state.libraryCards.presignedUrl;
